<div class="wrapper" >
  <i class="fa fa-signal" ></i>
  <div class="signal" [ngStyle]="getWidth()">
    <i class="fa fa-signal"></i>
  </div>
</div>
